import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import AgenticMatching from './AgenticMatching';
import { ICandidateSourcingSearch } from './types';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
});

export default function AgenticMatchingPage({
  searchObj
}: {
  searchObj: ICandidateSourcingSearch;
}) {
  return (
    <QueryClientProvider client={queryClient}>
      <AgenticMatching searchObj={searchObj} />
    </QueryClientProvider>
  );
}
